export const USE_DASHBOARD_INFO_EMPLOYEE = 'USE_DASHBOARD_INFO_EMPLOYEE';
export const USE_DASHBOARD_PROJECT_ALLOCATIONS = 'USE_DASHBOARD_PROJECT_ALLOCATIONS';
export const USE_DASHBOARD_PROJECT_ALLOCATIONS_BY_MONTH = 'USE_DASHBOARD_PROJECT_ALLOCATIONS_BY_MONTH';
export const USE_DASHBOARD_PROJECT_STATS = 'USE_DASHBOARD_PROJECT_STATS';
export const USE_DASHBOARD_INFO_ASSETS = 'USE_DASHBOARD_INFO_ASSETS';
export const USE_DASHBOARD_INFO_TIMEKEEPING = 'USE_DASHBOARD_INFO_TIMEKEEPING';
export const USE_DASHBOARD_INFO_TIMEKEEPING_DAY = 'USE_DASHBOARD_INFO_TIMEKEEPING_DAY';
export const USE_DASHBOARD_GET_REQUEST = 'USE_DASHBOARD_GET_REQUEST';
export const USE_DASHBOARD_GET_UNREPORTED_DAYS = 'USE_DASHBOARD_GET_UNREPORTED_DAYS';
